@import '~style-sheet-helpers/core.less';
@import '../../../../app-brand/entities/entity-layer.module.less';

.combine-customers-confirmation-modal {
  width: 1000px;
  margin: 30px 0;
}

.combine-customers-confirmation-modal-body {
  height: 150px;
  padding: 15px;
  font-size: 16px;
  line-height: 29px;
  color: @customer-page--modal--text-color;
}
